var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              width: "200",
              prop: "fileName",
              label: _vm.$t("billingPage.FileName"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "120",
              prop: "invoiceDate",
              label: _vm.$t("billingPage.InvoiceDate"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "120",
              prop: "operatedDate",
              label: _vm.$t("billingPage.OperatedDate"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "80",
              prop: "createdBy",
              label: _vm.$t("billingPage.Operator"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "chargedOrders",
              label: _vm.$t("billingPage.ChargedOrders"),
              align: "center",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }